"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.focusStyles = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactWebcam = _interopRequireDefault(require("react-webcam"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _frontlibUtil = require("@figure/frontlib-util");

var _util = require("../Util/util");

var _Constant = require("../Constant");

var _Button = _interopRequireDefault(require("../Button"));

var _placeholder = _interopRequireDefault(require("../../src/assets/images/placeholder.png"));

var _AllowedImageFormats = require("./AllowedImageFormats");

var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));

var _theme;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  transform: scale(0.8);\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  z-index: 0;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%) scale(", ");\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 80px;\n  padding: 5px 25px;\n  min-width: 120px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &[data-focus-visible-added]:focus {\n    ", "\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    margin-top: 20px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  bottom: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n\n  @media print, screen and (min-width: ", "px) {\n    position: static;\n    transform: none;\n    left: 0;\n    bottom: 0;\n    top: 25px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%);\n  z-index: 50;\n  text-align: center;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  overflow: hidden;\n  background-color: ", ";\n  &:after {\n    content: '';\n    background-image: url(", ");\n    background-repeat: repeat;\n    background-size: 48px 48px;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    position: absolute;\n    z-index: 0;\n    opacity: 0.1;\n    display: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * Homepoint buttons have not been themed yet, but I used a white icon on hover.
 * The black icon is very difficult to see against their current focused background color.
 * Figure Webcam buttons use PURPLE_RAIN instead of the MELLOW_YELLOW on focus that the Button uses.
 */
var focusStyles = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.FIGURE, "\n    background-color: ".concat(_Constant.Color.PURPLE_RAIN, ";\n    border-color: ").concat(_Constant.Color.PURPLE_RAIN, ";\n    box-shadow: 0 0 0 4px ").concat(_Constant.Color.FOCUS, ";\n    svg path, circle {\n      stroke: ").concat(_Constant.Color.WHITE, ";  \n      @media (forced-colors: active) {\n        stroke: currentColor;\n      }\n    }\n  ")), (0, _defineProperty2.default)(_theme, _Constant.Themes.PELLA, "\n    background-color: ".concat(_Constant.Color.PURPLE_RAIN, ";\n    border-color: ").concat(_Constant.Color.PURPLE_RAIN, ";\n    box-shadow: 0 0 0 4px ").concat(_Constant.Color.FOCUS, ";\n    svg path, circle {\n      stroke: ").concat(_Constant.Color.WHITE, ";  \n      @media (forced-colors: active) {\n        stroke: currentColor;\n      }\n    }\n  ")), (0, _defineProperty2.default)(_theme, _Constant.Themes.PETERSENDEAN, "\n    background-color: ".concat(_Constant.Color.PURPLE_RAIN, ";\n    border-color: ").concat(_Constant.Color.PURPLE_RAIN, ";\n    box-shadow: 0 0 0 4px ").concat(_Constant.Color.FOCUS, ";\n    svg path, circle {\n      stroke: ").concat(_Constant.Color.WHITE, ";  \n      @media (forced-colors: active) {\n        stroke: currentColor;\n      }\n    }\n  ")), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, "\n  background-color: ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";\n  border-color: ").concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";\n  box-shadow: 0 0 0 4px ").concat(_Constant.Color.FOCUS, ";\n  svg path, circle {\n    stroke: ").concat(_Constant.Color.WHITE, ";  \n    @media (forced-colors: active) {\n      stroke: currentColor;\n    }\n  }\n")), _theme)); // TODO: less arbitrary image size, though this is probably fine assuming these findings: https://stackoverflow.com/questions/6018611/smallest-data-uri-image-possible-for-a-transparent-image

exports.focusStyles = focusStyles;
var MIN_IMAGE_SIZE = 100; // the ButtonIcon is being created here rather than being passed as a background image so that it is visible for Windows high contrast mode users

var ButtonIcon = function ButtonIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 5C0 3.89543 0.895431 3 2 3H5.46482C5.79917 3 6.1114 2.8329 6.29687 2.5547L7.40627 0.890599C7.7772 0.334202 8.40166 0 9.07037 0H12.9296C13.5983 0 14.2228 0.334202 14.5937 0.8906L15.7031 2.5547C15.8886 2.8329 16.2008 3 16.5352 3H20C21.1046 3 22 3.89543 22 5V16C22 17.1046 21.1046 18 20 18H2C0.89543 18 0 17.1046 0 16V5Z",
    transform: "translate(5 7)",
    stroke: "currentColor",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(12 13)",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
};

var Screenshot = _styledComponents.default.div(_templateObject(), _Constant.Color.WHITE, _placeholder.default, function (props) {
  return props.mediaLoaded ? 'none' : 'block';
});

var LoadText = _styledComponents.default.h1(_templateObject2()); // the 'top' positioning is best-guess; the button used to be half inside
// the <video> element below the min-width breakpoint


var ButtonContainer = _styledComponents.default.div(_templateObject3(), _Constant.Width.MD);

var WebcamButton = (0, _styledComponents.default)(_Button.default)(_templateObject4(), focusStyles, _Constant.Width.MD);

var Container = _styledComponents.default.div(_templateObject5());

var ScaledWebcam = (0, _styledComponents.default)(_reactWebcam.default)(_templateObject6(), function (props) {
  return 1 / props.scale;
});

var Overlay = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.captureGuidelineOverlay;
});

var WebcamCapture = function WebcamCapture(_ref) {
  var captureGuidelineOverlay = _ref.captureGuidelineOverlay,
      onScreenshot = _ref.onScreenshot,
      _onUserMedia = _ref.onUserMedia,
      videoConstraints = _ref.videoConstraints,
      screenshotFormat = _ref.screenshotFormat,
      resizeDebouncePeriod = _ref.resizeDebouncePeriod;
  var containerRef = (0, _react.useRef)(null);
  var webcamRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      scale = _useState2[0],
      setScale = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      mediaLoaded = _useState4[0],
      setMediaLoaded = _useState4[1];

  var debouncedScale = (0, _frontlibUtil.useDebounce)(scale, resizeDebouncePeriod);
  (0, _react.useEffect)(function () {
    var onResize = function onResize() {
      var width = containerRef.current.offsetWidth;
      var newScale = videoConstraints.width / width;
      setScale(newScale);
    };

    onResize();
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [videoConstraints]);
  var videoStyles = {
    height: typeof debouncedScale === 'number' ? "".concat(videoConstraints.height / debouncedScale, "px") : 'initial'
  };

  var constraints = _objectSpread(_objectSpread({}, videoConstraints), {}, {
    facingMode: 'environment'
  });

  if (_util.isServer) return null;
  return /*#__PURE__*/_react.default.createElement(Container, {
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(Screenshot, {
    className: "fs-exclude",
    style: videoStyles,
    mediaLoaded: mediaLoaded
  }, !mediaLoaded && /*#__PURE__*/_react.default.createElement(LoadText, null, "Please enable webcam..."), /*#__PURE__*/_react.default.createElement(ScaledWebcam, {
    audio: false,
    width: videoConstraints.width,
    height: videoConstraints.height,
    onUserMedia: function onUserMedia() {
      setMediaLoaded(true);

      _onUserMedia();
    },
    ref: webcamRef,
    scale: debouncedScale,
    screenshotFormat: screenshotFormat,
    videoConstraints: constraints
  }), captureGuidelineOverlay && /*#__PURE__*/_react.default.createElement(Overlay, {
    captureGuidelineOverlay: captureGuidelineOverlay
  })), /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement(WebcamButton, {
    type: "button",
    onClick: function onClick() {
      var currentWebcamRef = webcamRef.current;
      var screenshot = currentWebcamRef.getScreenshot();
      var canvas = currentWebcamRef.canvas;
      if (screenshot === null || canvas === null) return;
      if (typeof screenshot === 'string' && screenshot.length < MIN_IMAGE_SIZE) return; // Handles very small images being base64 encoded

      onScreenshot(screenshot, canvas);
    },
    primary: true,
    large: true,
    center: true
  }, /*#__PURE__*/_react.default.createElement(ButtonIcon, null), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, "Take picture"))));
};

WebcamCapture.propTypes = {
  /** callback for when component recieves media stream */
  onUserMedia: _propTypes.default.func,

  /** An URL to an image that will be overlaid on top of the webcam footage */
  captureGuidelineOverlay: _propTypes.default.string,

  /** callback for when a webcam capture is taken */
  onScreenshot: _propTypes.default.func.isRequired,

  /** The file format for the image */
  screenshotFormat: _propTypes.default.oneOf(_AllowedImageFormats.ALLOWED_IMAGE_FORMATS).isRequired,

  /** Debounce period for multiple resize calls */
  resizeDebouncePeriod: _propTypes.default.number,

  /** height and width for screenshot image */
  videoConstraints: _propTypes.default.shape({
    width: _propTypes.default.number,
    height: _propTypes.default.number
  })
};
WebcamCapture.defaultProps = {
  captureGuidelineOverlay: null,
  onUserMedia: function onUserMedia() {},
  resizeDebouncePeriod: 200,
  videoConstraints: {
    width: 1600,
    height: 1075
  }
};
var _default = WebcamCapture;
exports.default = _default;